(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ew-homepage-v6"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const desktopMedia = window.matchMedia('(min-width: 750px)');
    let observer = null;

    const mountStudio = () => {
      const template = document.querySelector('[data-ew-home-studio-template]');
      const root = document.querySelector('section.ew-home-v14');
      if (!template || !root) return false;

      root.querySelectorAll('[data-ew-home-studio]').forEach((oldStage) => oldStage.remove());

      const fragment = template.content.cloneNode(true);
      const stage = fragment.querySelector('[data-ew-home-studio]');
      if (!stage) return false;

      root.prepend(fragment);
      const hero = root.querySelector('.ew-hero');
      const cards = root.querySelectorAll('[data-ew-studio-card]');

      if (!reduceMotion && desktopMedia.matches && hero) {
        let frame = 0;
        let pointerX = .5;
        let pointerY = .5;

        const renderDepth = () => {
          const offsetX = pointerX - .5;
          const offsetY = pointerY - .5;
          stage.style.setProperty('--ew-studio-x', `${offsetX * 10}px`);
          stage.style.setProperty('--ew-studio-y', `${offsetY * 7}px`);
          stage.style.setProperty('--ew-studio-rx', `${offsetY * -1.2}deg`);
          stage.style.setProperty('--ew-studio-ry', `${offsetX * 1.5}deg`);
          stage.style.setProperty('--ew-light-x', `${27 + offsetX * 9}%`);
          stage.style.setProperty('--ew-light-y', `${32 + offsetY * 7}%`);
          frame = 0;
        };

        hero.addEventListener('pointermove', (event) => {
          const bounds = hero.getBoundingClientRect();
          pointerX = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
          pointerY = Math.min(1, Math.max(0, (event.clientY - bounds.top) / bounds.height));
          if (!frame) frame = requestAnimationFrame(renderDepth);
        }, { passive: true });

        hero.addEventListener('pointerleave', () => {
          pointerX = .5;
          pointerY = .5;
          if (!frame) frame = requestAnimationFrame(renderDepth);
        }, { passive: true });

        cards.forEach((card) => {
          let cardFrame = 0;
          let cardX = .5;
          let cardY = .5;

          const renderCard = () => {
            const x = cardX - .5;
            const y = cardY - .5;
            card.style.setProperty('--ew-card-rx', `${y * -7}deg`);
            card.style.setProperty('--ew-card-ry', `${x * 9}deg`);
            card.style.setProperty('--ew-card-light-x', `${cardX * 100}%`);
            card.style.setProperty('--ew-card-light-y', `${cardY * 100}%`);
            cardFrame = 0;
          };

          card.addEventListener('pointermove', (event) => {
            const bounds = card.getBoundingClientRect();
            cardX = Math.min(1, Math.max(0, (event.clientX - bounds.left) / bounds.width));
            cardY = Math.min(1, Math.max(0, (event.clientY - bounds.top) / bounds.height));
            if (!cardFrame) cardFrame = requestAnimationFrame(renderCard);
          }, { passive: true });

          card.addEventListener('pointerleave', () => {
            cardX = .5;
            cardY = .18;
            if (!cardFrame) cardFrame = requestAnimationFrame(renderCard);
          }, { passive: true });
        });
      }

      return true;
    };

    const boot = () => {
      if (mountStudio()) {
        if (observer) observer.disconnect();
        return;
      }

      if (!observer) {
        observer = new MutationObserver(() => {
          if (mountStudio()) observer.disconnect();
        });
        observer.observe(document.documentElement, { childList: true, subtree: true });
      }
    };

    boot();
    document.addEventListener('shopify:section:load', () => requestAnimationFrame(boot));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
